import { INotification } from "infrastructure/notification";
import { IValidationIssue } from "infrastructure/validation";

export interface IPlexTranslationUploadError {
  validationIssues?: IPlexTranslationUploadValidationIssue[];
  text?: string;
}

export interface IPlexTranslationUploadValidationIssue {
  uniqueId: string;
  messageId: string;
  messageTranslation: string;
  locale: string;
  industry: string;
  validationIssue: IValidationIssue;
}

export interface IPlexTranslationUploadState {
  uploadProcessing: boolean;
  uploadCompleted: boolean;
  error?: IPlexTranslationUploadError;
  notifications: INotification[];
  progress: number;
}

export const getInitialPlexTranslationUploadState = (): IPlexTranslationUploadState => ({
  uploadProcessing: false,
  uploadCompleted: false,
  notifications: [],
  progress: 0
});
